<template>
  <div>
    <div class="bg">
      <Nav @getTime="getTime" @address="address" title="互联网数据中心"></Nav>
      <div style="margin-top: 20px;display: flex;justify-content: space-between;align-items: center;height: 30%">
        <div style="width: 39%;background-color: #111b27;height: 100%;border-radius: 12px">
          <div class="border-box-content-small">
            <div @click="changeColor(index,i.id)"
                 :class="['border-box-content-number', { colorBgc: indexColor == index }]"
                 v-for="(i, index) in dataList" v-bind:key="index">
              <div style="display: flex;justify-content: center;align-items: center">
                <el-image v-if="i.image" style="width: 25%;height: 25%;" :src="i.image"></el-image>
                <i v-else style="color:#1958a1;font-size: 35px" class="el-icon-menu"></i>
                <div>
                  <div v-if="i.name === '全部' ">信源总量</div>
                  <div v-else> {{i.name}} </div>
                  <div>{{ i.count }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 59%;background-color: #111b27;height: 100%;border-radius: 12px">
          <div style="display: flex;justify-content: space-between;align-items: center;height: 100%">
            <div style="height: 100%;width: 65%">
              <h3 class="titleStyle backGround-line">信源趋势图</h3>
              <div id="chart_1" style="width: 90%;height: 100%;margin: 0 auto;" class="chart"></div>
            </div>
            <div style="width: 35%;height: 100%;">
              <div class="backGround-line">信源占比</div>
              <div id="chart_2" style="width: 90%;height: 100%;margin: 0 auto;"></div>
            </div>
          </div>
        </div>
      </div>
      <div
          style="display: flex; justify-content: space-between; align-items: stretch; height: calc(100% - 30% - 160px);margin-top: 10px;">
        <div style="width: 24%;">
          <div style="background-color: #111b27;height: 100%;border-radius: 12px">
            <div style="display: flex;flex-direction: column;height: 100%;">
             <div style="width: 100%;height: 100%">
               <div class="backGround-line">情绪分析</div>
               <div id="chart_4" style="width: 100%;height: 100%;margin: 0 auto;"></div>
             </div>
             <div  style="width: 100%;height: 100%">
               <div class="backGround-line">情绪分析占比</div>
               <div id="chart_4-1" style="width: 100%;height: 100%;margin: 0 auto;"></div>
             </div>
            </div>
          </div>
        </div>
        <div style="width: 39%;">
          <div style="background-color: #111b27;height: 100%;border-radius: 12px">
            <div style="height: 100%;">
              <div class="backGround-line">数据信息源排行</div>
              <div id="chart_3" style="width: 100%;height: 100%;margin: 0 auto;"></div>
            </div>
          </div>
        </div>
        <div style="width: 34%;">
          <div style="background-color: #111b27;height: 100%;border-radius: 12px">
            <div style="display: flex;flex-direction: column;justify-content: space-between;height: 100%;">
              <div style="height: 38%;">
                <div class="titleStyle backGround-line">热议词云</div>
                <div id="chart_5" style="margin: 0 auto;height: 90%"></div>
              </div>
              <div style="height: 60%;">
                <div class="titleStyle">最新数据</div>
                <div class="overflow-box">
                  <div v-for="(i, index) in data.slice(0, 10)" :key="index" style="height: 65px;"
                       :class="[index % 2 != 0 ? 'bgColor' : '']">
                    <div style="display: flex;justify-content: space-between;align-items: center;padding: 5px;">
                      <div style="display: flex;justify-content: left;align-items: center;width: 85%;">
                        <div style="text-align: left">{{ index + 1 }}</div>
                        <div class="text-multi-line-ellipsis">{{ i.desc }}</div>
                      </div>
                      <div>
                        <el-button @click="details(i.url)" style="background-color: transparent;" size="mini">详情
                        </el-button>
                      </div>
                    </div>
                    <div style="padding: 5px;display: flex;justify-content: space-between;align-items: center;">
                      <div>传播力:{{ i.keyword }}</div>
                      <div style="display: flex;justify-content: left;align-items: center;">
                        <i class="el-icon-picture-outline-round"></i>
                        <div>{{ i.source }}</div>
                      </div>
                      <div>
                        <i class="el-icon-time"></i>
                        {{ i.publish_time }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Nav from "@/components/Nav/Nav.vue"
// import china from "@/assets/china.json"
import * as echarts from 'echarts';
import 'echarts-wordcloud'
import drawMixin from "../../utils/drawMixin";
import {
  datacenterIndex,
  datacenterGetsourcetrend,
  datacenterGetsourcerate,
  datacenterGetemotiontrend,
  datacenterGetheatedtopic,
  datacenterGetlatestnews, datacenterGetsourcetop10, datacenterGetemotionrate
} from "@/request/dataCenterScreenInterFace/dataCenterScreen";
import getWeakData from "@/utils/getWeekDates/getWeenDates";


export default {
  mixins: [drawMixin],
  components: {
    Nav
  },
  data() {
    return {
      headerHeight: 0, // 新增字段保存头部高度
      title: "互联网数据中心",
      loading: true,
      value1: "", //
      value2: ' ',
      dataList: '',    // 十个的总数据
      indexColor: null,// 用来记录选中的颜色
      dataName: [],  // 存储信源趋势图的名字
      dataMotiontrendName: [],  // 存储情绪图的名字
      dataCenter: [
        {data: {day: getWeakData(), count: [0, 0, 0, 0, 0, 0, 0]}},
        {data: {count: [0, 0, 0, 0, 0, 0, 0]}},
        {data: {count: [0, 0, 0, 0, 0, 0, 0]}},
        {data: {count: [0, 0, 0, 0, 0, 0, 0]}},
        {data: {count: [0, 0, 0, 0, 0, 0, 0]}},
        {data: {count: [0, 0, 0, 0, 0, 0, 0]}},
        {data: {count: [0, 0, 0, 0, 0, 0, 0]}},
        {data: {count: [0, 0, 0, 0, 0, 0, 0]}},
        {data: {count: [0, 0, 0, 0, 0, 0, 0]}}],// 存储信源趋势图的数据，默认没有数据展示的
      dataCentergetSourcerate: [], // 信源占比图数据
      dataCenterMotiontrend: [],// 情绪折线数据
      dataProportionEmotions: [], // 情绪占比图数据
      dataCloudWord: [], // 词云热议话题数据
      dataDataSources: [], // 数据来源的数据
      dataTime: {},  // 存储选取的时间
      chart_1: null,  //信源趋势图
      chart_2: null, // 信源占比图
      chart_3: null, // 数据来源图
      chart_4: null, // 实列情绪
      chart_5: null,// 词云图
      chart_6: null, // 情绪占比图
      data: [],// 最新数据


    }
  },
  async mounted() {
    this.openFullScreen2()
    await this.dataCenterIndex()   // 首页的数据量
    await this.datacenterGetemotiontrend() // 情绪的数据量
    await this.datacenterGetheatedtopic() // 词云图热点话题默认加载
    await this.datacenterGetlatestnews()  // 最新数据默认加载
    await this.datacenterGetsourcetop10() // 默认加载数据来源top10
    await this.datacenterGetemotionrate() // 默认加载情绪占比图
    this.$nextTick(() => {
      this.chart0()
      this.chart1()
      this.chart2()
      this.chart3()
      this.chart4()
      this.Chart5()
    })
    this.loading.close()
    window.addEventListener('resize',this.handleResize);
  },
  methods: {
    chart0() {
      this.chart_1 = echarts.init(document.getElementById("chart_1"))
      const legend = [];
      this.dataName.forEach(item => {
        legend.push(item);
      });
      var colors = [
        "#FF5733",
        "#33FF57",
        "#3357FF",
        "#FF33A1",
        "#9033FF",
        "#33FFF6",
        "#FFBD33",
        "#FF3333",
        "#FFFFFF"
      ];

      const  updata = ()=>{
        const  list = []
        for (let i = 0; i < legend.length; i++) {
          const obj = {
             name: legend[i],
             type: "line",
             itemStyle: {color: colors[i]},
             label:{show:true},
             data:this.dataCenter[i].data.count
          }
          list.push(obj)
        }
        return list
      }
      var xAxisData = this.dataCenter[0].data.day;
      this.chart_1.setOption({
        grid: {
          top: 70,
          bottom: 90,
          left: 65,
          right: 65
        },
        tooltip: {
          trigger: 'axis',

          position: function (pt) {
            return [pt[0], '25%'];
          }
        },
        legend: {
          data: legend,
          textStyle: {  // 控制图例文字样式
            color: '#353bbc', // 修改为白色
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        toolbox: {
          show: false,
          feature: {
            dataView: {readOnly: false},
            magicType: {type: ['line', 'bar']},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData
        },
        yAxis: {
          type: 'value',
        },
        series: updata()
      })
    },
    // 信源占比图
    chart1() {
      this.chart_2 = echarts.init(document.getElementById('chart_2'))
      datacenterGetsourcerate().then(res => {
        this.dataCentergetSourcerate = res.data.data   // 替换信源占比图数据
        const option = {
          colors: [
            "#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"
          ],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: [],
            },
          ],
        }
        const arrList = []
        for (let i = 0; i < this.dataCentergetSourcerate.length; i++) {
          arrList[i] = {
            name: this.dataCentergetSourcerate[i].name,
            value: this.dataCentergetSourcerate[i].percent,
          }
        }
        option.series[0].data = arrList
        this.chart_2.setOption(option)
      })

    },
    // 数据来源
    chart2() {
      this.chart_3 = echarts.init(document.getElementById('chart_3'))
      const Xdata = this.dataDataSources.map((item) => {
        return item.source_name
      })
      const Ydata = this.dataDataSources.map((item) => {
        return item.total_sum
      })
      const option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis', // 按坐标轴触发（适合柱状图）
          axisPointer: {
            type: 'shadow' // 阴影指示器（可选：line、shadow、none）
          },
          backgroundColor: '#fff', // 提示框背景色
          textStyle: {
            color: '#000000' // 提示框文字颜色
          },
          // 可选：自定义提示框内容
          formatter: function (params) {
            return `${params[0].axisValue}<br/>数量: ${params[0].value}`;
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: Xdata,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#063374",
              width: 1,
              type: "solid"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#00c7ff",
              fontSize: "8"
            },
            interval: 0, // 强制显示所有标签

          },
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#00c7ff",
              width: 1,
              type: "solid"
            },
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: "#063374",
            }
          }
        }],
        series: [{
          type: 'bar',
          data: Ydata,
          barWidth: 20,
          barGap: 1, //柱子之间间距
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#00fcae'
              }, {
                offset: 1,
                color: '#006388'
              }]),
              opacity: 1,
            }
          }
        }]
      }
      this.chart_3.setOption(option)
    },
    // 情绪折线图
    chart3() {
      this.chart_4 = echarts.init(document.getElementById('chart_4'))
      const legend = [];
      this.dataMotiontrendName.forEach(item => {
        legend.push(item);
      });
      var colors = [
        "#FF5733",
        "#33FF57",
        "#3357FF",];
      var xAxisData = this.dataCenterMotiontrend[0].data.day;
      const  updata = ()=>{
        const  list = []
        for (let i = 0; i < legend.length; i++) {
          const obj = {
            name: legend[i],
            type: "line",
            itemStyle: {color: colors[i]},
            label:{show:true},
            data:this.dataCenterMotiontrend[i].data.count
          }
          list.push(obj)
        }
        return list
      }
      this.chart_4.setOption({
        grid: {
          top: 70,
          bottom: 90,
          left: 65,
          right: 65
        },
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '25%'];
          }
        },
        legend: {
          data: legend,
          textStyle: {  // 控制图例文字样式
            color: '#353bbc', // 修改为白色
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        toolbox: {
          show: false,
          feature: {

            dataView: {readOnly: false},
            magicType: {type: ['line', 'bar']},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData
        },
        yAxis: {
          type: 'value',
        },
        series: updata()
      })
    },
    // 词云图 热点话题
    chart4() {
      this.chart_5 = echarts.init(document.getElementById('chart_5'))
      const data = this.dataCloudWord
      this.chart_5.setOption({
        grid: {
          top: '0%',    // 上边距
          right: '0%',   // 右边距
          bottom: '20%', // 下边距
          left: '0%',    // 左边距
        },
        series: [
          {
            type: "wordCloud",
            // 网格大小，各项之间间距
            gridSize: 12,
            // 形状 circle 圆，cardioid  心， diamond 菱形，
            // triangle-forward 、triangle 三角，star五角星
            shape: 'circle',
            // 字体大小范围
            sizeRange: [12, 20],
            // 文字旋转角度范围
            rotationRange: [0, 0],
            // 旋转步值
            rotationStep: 90,
            // 自定义图形
            // maskImage: maskImage,
            left: 'center',
            top: 'center',
            right: null,
            // 画布宽
            width: '100%',
            // 画布高
            height: '100%',
            // 是否渲染超出画布的文字
            drawOutOfBound: false,
            textStyle: {
              color: function () {
                const colors = ['#165DFF', '#6aca37',
                  '#05a4b6', '#f93920', '#f0b114']
                return colors[parseInt(Math.random() * (colors.length))];
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: '#2ac'
              }
            },
            data: data
          }
        ]
      })
    },
    // 情绪占比图
    Chart5() {
      this.chart_6 = echarts.init(document.getElementById('chart_4-1'))
      var data = this.dataProportionEmotions.value.map(((item, index) => {
        return {
          value: item,
          name: this.dataProportionEmotions.name[index]
        }
      }))
      const option = {
        color: ["#FF5733",
          "#33FF57",
          "#3357FF",],

        legend: {
          show: true,
          bottom: "10%",
          icon: "circle",
          textStyle: {  // 控制图例文字样式
            color: '#353bbc', // 修改为白色
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        title: [
          {
            left: "0",
            top: "0",
            textStyle: {
              fontSize: 18,
              fontWeight: "bold",
              color: "#fff",
            },
          },
          {
            textStyle: {
              color: "#fff",
              fontSize: "12px",
              fontWeight: "normal",
            },
            subtextStyle: {
              color: "#fff",
              fontSize: "20px",
              fontWeight: "600",
            },
            top: "center",
            left: "center",
          },
        ],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["30%", "55%"],
            center: ["50%", "40%"],
            avoidLabelOverlap: false,
            label: {
              formatter: `{b|{d}%}`,
              alignTo: "labelLine",
              rich: {
                a: {
                  color: "#fff",
                  fontSize: "12px",
                },
                b: {
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "600",
                },
              },
            },
            labelLine: {
              lineStyle: {
                cap: "round",
              },
            },
            data: data,
          },
        ],
      }
      this.chart_6.setOption(option)
    },
    // 点击后改变数据
    async changeColor(index, id) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.indexColor = index
      this.dataTime.categoryId = id
      // 点击改变信源占比图数据
      // datacenterGetsourcerate(this.dataTime).then(res => {
      //   // console.log(res, '信源占比图')
      //   this.dataCentergetSourcerate = res.data.data   // 替换信源占比图数据
      //   const option = {
      //     color: [
      //       "#33FF57",
      //     ],
      //     legend: {
      //       show: true,
      //       bottom: "10%",
      //       icon: "circle",
      //     },
      //     title: [
      //       {
      //         left: "0",
      //         top: "0",
      //         textStyle: {
      //           fontSize: 18,
      //           fontWeight: "bold",
      //           color: "#fff",
      //         },
      //       },
      //       {
      //         textStyle: {
      //           color: "#fff",
      //           fontSize: "12px",
      //           fontWeight: "normal",
      //         },
      //         subtextStyle: {
      //           color: "#fff",
      //           fontSize: "20px",
      //           fontWeight: "600",
      //         },
      //         top: "center",
      //         left: "center",
      //       },
      //     ],
      //     series: [
      //       {
      //         name: "",
      //         type: "pie",
      //         radius: ["30%", "55%"],
      //         center: ["50%", "38%"],
      //         avoidLabelOverlap: false,
      //         label: {
      //           formatter: `{b|{d}%}`,
      //           alignTo: "labelLine",
      //           rich: {
      //             a: {
      //               color: "#fff",
      //               fontSize: "12px",
      //             },
      //             b: {
      //               color: "#fff",
      //               fontSize: "14px",
      //               fontWeight: "600",
      //             },
      //           },
      //         },
      //         labelLine: {
      //           lineStyle: {
      //             cap: "round",
      //           },
      //         },
      //         data: [],
      //       },
      //     ],
      //   }
      //   const arrList = []
      //   for (let i = 0; i < this.dataCentergetSourcerate.length; i++) {
      //     arrList[i] = {
      //       name: this.dataCentergetSourcerate[i].name,
      //       value: this.dataCentergetSourcerate[i].percent,
      //     }
      //   }
      //   // console.log(arrList)
      //   option.series[0].data = arrList
      //   this.chart_2.setOption(option)
      // })
      // 点击改变情绪折线图数据
      datacenterGetemotiontrend(this.dataTime).then(res => {
        this.dataCenterMotiontrend = res.data.data
        const legend = [];
        this.dataMotiontrendName.forEach(item => {
          legend.push(item);
        });
        var colors = [
          "#FF5733",
          "#33FF57",
          "#3357FF",];
        var xAxisData = this.dataCenterMotiontrend[0].data.day;
        const  updata = ()=>{
          const  list = []
          for (let i = 0; i < legend.length; i++) {
            const obj = {
              name: legend[i],
              type: "line",
              itemStyle: {color: colors[i]},
              label:{show:true},
              data:this.dataCenterMotiontrend[i].data.count
            }
            list.push(obj)
          }
          return list
        }
        this.chart_4.setOption({
          grid: {
            top: 70,
            bottom: 90,
            left: 65,
            right: 65
          },
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '25%'];
            }
          },
          legend: {
            data: legend
          },
          toolbox: {
            show: false,
            feature: {

              dataView: {readOnly: false},
              magicType: {type: ['line', 'bar']},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData
          },
          yAxis: {
            type: 'value',
          },
          // dataZoom: [{
          //   zoomLock: false,
          //   startValue: '0',
          //   endValue: xAxisData[10],
          //   rangeMode: ["percent", "value"]
          // }],
          series: updata()
        })
      })
      // 点击改变词云图热点话题数据
      datacenterGetheatedtopic(this.dataTime).then((res) => {
        const data = res.data.data.map((item) => ({
          "name": item.keyword,
          "value": item.count
        }))
        this.chart_5.setOption({
          grid: {
            top: '0%',    // 上边距
            right: '0%',   // 右边距
            bottom: '20%', // 下边距
            left: '0%',    // 左边距
          },
          series: [
            {
              type: "wordCloud",
              // 网格大小，各项之间间距
              gridSize: 12,
              // 形状 circle 圆，cardioid  心， diamond 菱形，
              // triangle-forward 、triangle 三角，star五角星
              shape: 'circle',
              // 字体大小范围
              sizeRange: [12, 20],
              // 文字旋转角度范围
              rotationRange: [0, 0],
              // 旋转步值
              rotationStep: 90,
              // 自定义图形
              // maskImage: maskImage,
              left: 'center',
              top: 'center',
              right: null,
              // 画布宽
              width: '100%',
              // 画布高
              height: '100%',
              // 是否渲染超出画布的文字
              drawOutOfBound: false,
              textStyle: {
                color: function () {
                  const colors = ['#165DFF', '#6aca37',
                    '#05a4b6', '#f93920', '#f0b114']
                  return colors[parseInt(Math.random() * (colors.length))];
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: '#2ac'
                }
              },
              data: data
            }
          ]
        })
      })
      // 点击改变最新数据
      datacenterGetlatestnews(this.dataTime).then((res) => {
        this.data = res.data.data
      })
      // 点击改变数据来源TOP
      datacenterGetsourcetop10(this.dataTime).then((res) => {
        this.dataDataSources = res.data.data
        const Xdata = this.dataDataSources.map((item) => {
          return item.source_name
        })
        const Ydata = this.dataDataSources.map((item) => {
          return item.total_sum
        })
        const option = {
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'axis', // 按坐标轴触发（适合柱状图）
            axisPointer: {
              type: 'shadow' // 阴影指示器（可选：line、shadow、none）
            },
            backgroundColor: '#fff', // 提示框背景色
            textStyle: {
              color: '#000000' // 提示框文字颜色
            },
            // 可选：自定义提示框内容
            formatter: function (params) {
              return `${params[0].axisValue}<br/>数量: ${params[0].value}`;
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: Xdata,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: Ydata,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        }
        this.chart_3.setOption(option)
      })
      // 点击改变情绪占比图
      datacenterGetemotionrate(this.dataTime).then((res) => {
        this.dataProportionEmotions = res.data.data
        var data = this.dataProportionEmotions.value.map(((item, index) => {
          return {
            value: item,
            name: this.dataProportionEmotions.name[index]
          }
        }))
        const option = {
          color: ["#FF5733",
            "#33FF57",
            "#3357FF",],

          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "40%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: data,
            },
          ],
        }
        this.chart_6.setOption(option)
      })
      if (id == '') {
        const res = await datacenterGetsourcetrend(this.dataTime)
        this.dataCenter = res.data.data
        this.dataName = this.dataCenter.map((item) => {
          return item.name
        })
        this.chart0()
      } else {
        // 信源趋势图
        this.chart_1.clear()
        const res = await datacenterGetsourcetrend(this.dataTime)
        // console.log(res)
        this.dataCenter = res.data.data
        this.dataName = res.data.data[0].name
        var legend = [this.dataName];
        var colors = ["#FF5733"];
        var xAxisData = this.dataCenter[0].data.day;
        var seriesDataA = this.dataCenter[0].data.count;
        this.chart_1.setOption({
          grid: {
            top: 70,
            bottom: 90,
            left: 65,
            right: 65
          },
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '25%'];
            }
          },
          legend: {
            data: legend,
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          toolbox: {
            show: false,
            feature: {

              dataView: {readOnly: false},
              magicType: {type: ['line', 'bar']},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              name: legend[0],
              type: 'line',
              itemStyle: {color: colors[0]},
              label: {show: true},
              data: seriesDataA
            },]
        })
      }
      loading.close();
    },
    // 默认数据源数据的名字
    async dataCenterIndex() {
      const res = await datacenterIndex()
      this.dataList = res.data.data
      this.dataList.reverse()
      // 存储数据源的各个名字
      this.dataName = this.dataList.map(item => {
        return item.name
      })
      this.dataName.pop()
      // 存储情绪的各个名字
    },
    // 默认情绪折线数据图
    async datacenterGetemotiontrend() {
      const res = await datacenterGetemotiontrend(this.dataTime)
      this.dataCenterMotiontrend = res.data.data
      this.dataMotiontrendName = res.data.data.map(item => {
        return item.name
      })
    },
    // 默认加载的词云图热点话题
    async datacenterGetheatedtopic() {
      const res = await datacenterGetheatedtopic(this.dataTime)
      this.dataCloudWord = res.data.data.map((item) => ({
        "name": item.keyword,
        "value": item.count
      }))
    },
    // 默认加载的最新数据
    async datacenterGetlatestnews() {
      const res = await datacenterGetlatestnews()
      this.data = res.data.data
    },
    // 默认加载数据来源
    async datacenterGetsourcetop10() {
      const res = await datacenterGetsourcetop10()
      this.dataDataSources = res.data.data
    },
    // 默认加载情绪占比图
    async datacenterGetemotionrate() {
      const res = await datacenterGetemotionrate()
      this.dataProportionEmotions = res.data.data
      console.log(this.dataProportionEmotions)
    },
    getTime(value) {
      this.dataTime.startTime = value[0]
      this.dataTime.endTime = value[1]
      if( this.indexColor !== null){
        // 点击改变信源占比图数据
        // datacenterGetsourcerate(this.dataTime).then(res => {
        //   // console.log(res, '信源占比图')
        //   this.dataCentergetSourcerate = res.data.data   // 替换信源占比图数据
        //   const option = {
        //     color: [
        //       "#33FF57",
        //     ],
        //     legend: {
        //       show: true,
        //       bottom: "10%",
        //       icon: "circle",
        //     },
        //     title: [
        //       {
        //         left: "0",
        //         top: "0",
        //         textStyle: {
        //           fontSize: 18,
        //           fontWeight: "bold",
        //           color: "#fff",
        //         },
        //       },
        //       {
        //         textStyle: {
        //           color: "#fff",
        //           fontSize: "12px",
        //           fontWeight: "normal",
        //         },
        //         subtextStyle: {
        //           color: "#fff",
        //           fontSize: "20px",
        //           fontWeight: "600",
        //         },
        //         top: "center",
        //         left: "center",
        //       },
        //     ],
        //     series: [
        //       {
        //         name: "",
        //         type: "pie",
        //         radius: ["30%", "55%"],
        //         center: ["50%", "38%"],
        //         avoidLabelOverlap: false,
        //         label: {
        //           formatter: `{b|{d}%}`,
        //           alignTo: "labelLine",
        //           rich: {
        //             a: {
        //               color: "#fff",
        //               fontSize: "12px",
        //             },
        //             b: {
        //               color: "#fff",
        //               fontSize: "14px",
        //               fontWeight: "600",
        //             },
        //           },
        //         },
        //         labelLine: {
        //           lineStyle: {
        //             cap: "round",
        //           },
        //         },
        //         data: [],
        //       },
        //     ],
        //   }
        //   const arrList = []
        //   for (let i = 0; i < this.dataCentergetSourcerate.length; i++) {
        //     arrList[i] = {
        //       name: this.dataCentergetSourcerate[i].name,
        //       value: this.dataCentergetSourcerate[i].percent,
        //     }
        //   }
        //   // console.log(arrList)
        //   option.series[0].data = arrList
        //   this.chart_2.setOption(option)
        // })
        // 点击改变情绪折线图数据
        datacenterGetemotiontrend(this.dataTime).then(res => {
          this.dataCenterMotiontrend = res.data.data
          const legend = [];
          this.dataMotiontrendName.forEach(item => {
            legend.push(item);
          });
          var colors = [
            "#FF5733",
            "#33FF57",
            "#3357FF",];
          var xAxisData = this.dataCenterMotiontrend[0].data.day;
          const  updata = ()=>{
            const  list = []
            for (let i = 0; i < legend.length; i++) {
              const obj = {
                name: legend[i],
                type: "line",
                itemStyle: {color: colors[i]},
                label:{show:true},
                data:this.dataCenterMotiontrend[i].data.count
              }
              list.push(obj)
            }
            return list
          }
          this.chart_4.setOption({
            grid: {
              top: 70,
              bottom: 90,
              left: 65,
              right: 65
            },
            tooltip: {
              trigger: 'axis',
              position: function (pt) {
                return [pt[0], '25%'];
              }
            },
            legend: {
              data: legend
            },
            toolbox: {
              show: false,
              feature: {

                dataView: {readOnly: false},
                magicType: {type: ['line', 'bar']},
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: xAxisData
            },
            yAxis: {
              type: 'value',
            },
            // dataZoom: [{
            //   zoomLock: false,
            //   startValue: '0',
            //   endValue: xAxisData[10],
            //   rangeMode: ["percent", "value"]
            // }],
            series: updata()
          })
        })
        // 点击改变词云图热点话题数据
        datacenterGetheatedtopic(this.dataTime).then((res) => {
          const data = res.data.data.map((item) => ({
            "name": item.keyword,
            "value": item.count
          }))
          this.chart_5.setOption({
            grid: {
              top: '0%',    // 上边距
              right: '0%',   // 右边距
              bottom: '20%', // 下边距
              left: '0%',    // 左边距
            },
            series: [
              {
                type: "wordCloud",
                // 网格大小，各项之间间距
                gridSize: 12,
                // 形状 circle 圆，cardioid  心， diamond 菱形，
                // triangle-forward 、triangle 三角，star五角星
                shape: 'circle',
                // 字体大小范围
                sizeRange: [12, 20],
                // 文字旋转角度范围
                rotationRange: [0, 0],
                // 旋转步值
                rotationStep: 90,
                // 自定义图形
                // maskImage: maskImage,
                left: 'center',
                top: 'center',
                right: null,
                // 画布宽
                width: '100%',
                // 画布高
                height: '100%',
                // 是否渲染超出画布的文字
                drawOutOfBound: false,
                textStyle: {
                  color: function () {
                    const colors = ['#165DFF', '#6aca37',
                      '#05a4b6', '#f93920', '#f0b114']
                    return colors[parseInt(Math.random() * (colors.length))];
                  },
                  emphasis: {
                    shadowBlur: 10,
                    shadowColor: '#2ac'
                  }
                },
                data: data
              }
            ]
          })
        })
        // 点击改变最新数据
        datacenterGetlatestnews(this.dataTime).then((res) => {
          this.data = res.data.data
        })
        // 点击改变数据来源TOP
        datacenterGetsourcetop10(this.dataTime).then((res) => {
          this.dataDataSources = res.data.data
          const Xdata = this.dataDataSources.map((item) => {
            return item.source_name
          })
          const Ydata = this.dataDataSources.map((item) => {
            return item.total_sum
          })
          const option = {
            backgroundColor: 'transparent',
            tooltip: {
              trigger: 'axis', // 按坐标轴触发（适合柱状图）
              axisPointer: {
                type: 'shadow' // 阴影指示器（可选：line、shadow、none）
              },
              backgroundColor: '#fff', // 提示框背景色
              textStyle: {
                color: '#000000' // 提示框文字颜色
              },
              // 可选：自定义提示框内容
              formatter: function (params) {
                return `${params[0].axisValue}<br/>数量: ${params[0].value}`;
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '10%',
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              data: Xdata,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#063374",
                  width: 1,
                  type: "solid"
                }
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#00c7ff",
                  fontSize: "8"
                }
              },
            }],
            yAxis: [{
              type: 'value',
              axisLabel: {
                formatter: '{value}'
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#00c7ff",
                  width: 1,
                  type: "solid"
                },
              },
              axisTick: {
                show: false
              },
              splitLine: {
                lineStyle: {
                  color: "#063374",
                }
              }
            }],
            series: [{
              type: 'bar',
              data: Ydata,
              barWidth: 20,
              barGap: 1, //柱子之间间距
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00fcae'
                  }, {
                    offset: 1,
                    color: '#006388'
                  }]),
                  opacity: 1,
                }
              }
            }]
          }
          this.chart_3.setOption(option)
        })
        // 点击改变情绪占比图
        datacenterGetemotionrate(this.dataTime).then((res) => {
          this.dataProportionEmotions = res.data.data
          var data = this.dataProportionEmotions.value.map(((item, index) => {
            return {
              value: item,
              name: this.dataProportionEmotions.name[index]
            }
          }))
          const option = {
            color: ["#FF5733",
              "#33FF57",
              "#3357FF",],

            legend: {
              show: true,
              bottom: "10%",
              icon: "circle",
            },
            title: [
              {
                left: "0",
                top: "0",
                textStyle: {
                  fontSize: 18,
                  fontWeight: "bold",
                  color: "#fff",
                },
              },
              {
                textStyle: {
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "normal",
                },
                subtextStyle: {
                  color: "#fff",
                  fontSize: "20px",
                  fontWeight: "600",
                },
                top: "center",
                left: "center",
              },
            ],
            series: [
              {
                name: "",
                type: "pie",
                radius: ["30%", "55%"],
                center: ["50%", "40%"],
                avoidLabelOverlap: false,
                label: {
                  formatter: `{b|{d}%}`,
                  alignTo: "labelLine",
                  rich: {
                    a: {
                      color: "#fff",
                      fontSize: "12px",
                    },
                    b: {
                      color: "#fff",
                      fontSize: "14px",
                      fontWeight: "600",
                    },
                  },
                },
                labelLine: {
                  lineStyle: {
                    cap: "round",
                  },
                },
                data: data,
              },
            ],
          }
          this.chart_6.setOption(option)
        })
        if (this.dataTime.categoryId == 0) {
          const res =  datacenterGetsourcetrend(this.dataTime)
          this.dataCenter = res.data.data
          this.dataName = this.dataCenter.map((item) => {
            return item.name
          })
          this.chart0()
        } else {
          // 信源趋势图
          const res =  datacenterGetsourcetrend(this.dataTime)
          this.dataCenter = res.data.data
          this.dataName = res.data.data[0].name
          var legend = [this.dataName];
          var colors = ["#FF5733"];
          var xAxisData = this.dataCenter[0].data.day;
          var seriesDataA = this.dataCenter[0].data.count;
          this.chart_1.setOption({
            grid: {
              top: 70,
              bottom: 90,
              left: 65,
              right: 65
            },
            tooltip: {
              trigger: 'axis',
              position: function (pt) {
                return [pt[0], '25%'];
              }
            },
            legend: {
              data: legend,
              textStyle: {  // 控制图例文字样式
                color: '#353bbc', // 修改为白色
                fontSize: 12,
                fontWeight: 'bold'
              }
            },
            toolbox: {
              show: false,
              feature: {

                dataView: {readOnly: false},
                magicType: {type: ['line', 'bar']},
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: xAxisData
            },
            yAxis: {
              type: 'value',
            },
            series: [
              {
                name: legend[0],
                type: 'line',
                itemStyle: {color: colors[0]},
                label: {show: true},
                data: seriesDataA
              },]
          })
        }
      }

    },
    details(value) {
      window.open(value, '_blank');
    },
    address(value) {
      console.log(value)
    },
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 1)'
      });
    },
    handleResize() {
      this.chart_1.resize()
      this.chart_2.resize()
      this.chart_3.resize()
      this.chart_4.resize()
      this.chart_5.resize()
      this.chart_6.resize()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize',this.handleResize);
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
* {
  font-size: 14px;
  // color: white;
}

.bg {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  padding: 16px 16px 0 16px;
  background-image: url("../../assets/pageBg.png");
  background-size: cover;
  background-position: center center;
  overflow-y: hidden;
}

.trapezoid-box {
  width: 50%;
  height: 50px;
  background: #0f1325;
  // background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
  color: white;
  padding: 20px;
  box-sizing: border-box;
  clip-path: polygon(0% 0%,
    /* 左上 */
      80% 0%,
    /* 右上 */
      100% 100%,
    /* 右下 */
      0% 100% /* 左下 */
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: sans-serif;
}

.trapezoid-box-right {
  width: 50%;
  height: 50px;
  color: white;
  background: #0f1325;
  text-align: right;
  padding: 20px;
  box-sizing: border-box;
  clip-path: polygon(20% 0%,
    /* 左上 */
      100% 0%,
    /* 右上 */
      100% 100%,
    /* 右下 */
      0% 100% /* 左下 */
  );
  display: flex;
  // flex-direction: column;
  // justify-content: center;
  align-items: center;
  justify-content: flex-end;
  font-family: sans-serif;
}

.el-input__inner {
  background-color: transparent;
  border: none;
}

.border-box-content-small {
  width: 100%;
  height: 20%;
  display: grid;
  padding: 10px;
  grid-template-columns: repeat(4, 1fr);
  color: white;
  text-align: center;
}


.border-box-content-number {
  width: 90%;
  height: 80px;
  /* 固定高度 */
  padding: 10px;
  overflow: hidden;
  /* 隐藏溢出内容 */
  box-sizing: border-box;
  /* 确保 padding 不撑大盒子 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.border-box-content-number:hover{
  background-color: rgb(255, 255, 255, 0.1);
}

.colorBgc {
  background-color: rgb(255, 255, 255, 0.1);
  overflow: hidden;
}

.titleStyle {
  color: white;
  text-align: center;
  margin-top: 10px
}

.overflow-box {
  max-height: calc(100% - 30px);
  /* 假设每条高 60px，最多显示 10 条 */
  overflow-y: auto;
  /* 可选：加个边框好看点 */
  padding: 5px;
  color: white;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.text-multi-line-ellipsis {
  display: -webkit-box;
  /* 老式弹性盒子模型 */
  -webkit-box-orient: vertical;
  /* 内容垂直排列 */
  -webkit-line-clamp: 1;
  /* 最多显示几行 */
  overflow: hidden;
  /* 隐藏多余内容 */
  text-overflow: ellipsis;
  /* 溢出部分显示省略号 */
  margin-left: 5px;
}

.bgColor {
  background-color: rgb(255, 255, 255, 0.1);
}

/* 隐藏整个页面的滚动条 */

</style>
